const dev = false;
const globals = {
    NOMBRE: "Ropa Adrogué",
    WS: "https://india.openplus.net.ar/api",
    OPEN: "https://india.openplus.net.ar",
    CDN: [],
    enContruccion: false,
    soloCatalogo: false,
    whatsapp: "+5491123075043",
    whatsappLindo: "+54 911 2307-5043",
    anchoCarrito: "75vw",
    INSTAGRAM: "https://www.instagram.com/indiastyle.adrogue",
    FACEBOOK: "https://www.facebook.com/profile.php?id=61574156572953",
    LINKS: [
        { to: "/familias/ACCESORIOS", name: "ACCESORIOS" },
        { to: "/familias/BIJOU", name: "BIJOU" },
        { to: "/familias/CALZADO", name: "CALZADO" },
        { to: "/familias/INDUMENTARIA", name: "INDUMENTARIA" },
    ],
    NOIVA: "COORDINA EL ENVIO POR WHATSAPP <BR />PAGALO CON MERCADOPAGO O EN EFECTIVO CON 10% DE DESCUENTO",
    DIRECCION: "",
    HORARIO: "",
    FILTRO_MARCA: 'india',
    FILTRO_DEPOSITO: "2",
    // Si se define el logo aca, no lo trae del sistema
    // LOGO: https://xxxx
    // Para antes de que baje el logo de archivos
    PRELOGO: '/img/logo.png'
};

if (dev) {
    globals.CDN.push("http://localhost:4000");
} else {
    for(var c = 1; c <= 5; c++) {
        globals.CDN.push("https://cdn" + c + "-india.openplus.net.ar");
    }
}

if (dev) {
    globals.WS = "http://localhost:4000/api";
    globals.OPEN = "http://localhost:4000";
}

export default globals;
